import * as Sentry from "@sentry/browser";

let showLog: string | null = null;

if (typeof window !== "undefined") {
  showLog = localStorage.getItem("CONFIG-SHOW-LOG");
}

const sentryErrorLog = (error: unknown) => {
  // eslint-disable-next-line no-console
  if (showLog) console.error(error);
  Sentry.captureException(error);
};

export { sentryErrorLog };
